import { render, staticRenderFns } from "./regis_mena.vue?vue&type=template&id=4644193e&scoped=true&"
import script from "./regis_mena.vue?vue&type=script&lang=js&"
export * from "./regis_mena.vue?vue&type=script&lang=js&"
import style0 from "./regis_mena.vue?vue&type=style&index=0&id=4644193e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4644193e",
  null
  
)

export default component.exports